import {
  URLTutorials,
  URLForum,
  URLForumReports,
  emailSupport,
  emailContact,
  URLGarSortieConfiance,
  URLWebinarSubscription,
  URLCompany,
  cookieCommentoName,
  server,
} from "../config/settings-network.mjs";
import { clearAutoLogout } from "../services/http-common";
//import { version } from "../../package.json";
import packageInfo from "../../package.json";
import UserDataService from "../services/UserDataService.js";
import { isTokenValid } from "../services/http-common";

import {
  langsList,
  scholarSystemsList,
} from "../config/settings-langs-and-scholar-systems.mjs";

export default {
  data() {
    return {
      langsList: langsList,
      scholarSystemsList: scholarSystemsList,
      server: server,
      URLGarSortieConfiance: URLGarSortieConfiance,
      URLForum: URLForum,
      URLForumReports: URLForumReports,
      URLTutorials: URLTutorials,
      URLWebinarSubscription: URLWebinarSubscription,
      URLCompany: URLCompany,
      emailSupport: emailSupport,
      emailContact: emailContact,
    };
  },

  computed: {
    getURLTutorials() {
      const baseURL = this.URLTutorials;
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    getURLEmailSupport() {
      const baseURL = "mailto:" + this.emailSupport + "?subject=Contact";
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    // Was a link to the (now removed) forum's "feature request"/"bug report"
    // categories; now a direct mailto with a subject so it lands pre-tagged.
    getURLForumFeatureRequests() {
      const baseURL = "mailto:" + this.emailContact + "?subject=feature";
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    getURLForumBugReports() {
      const baseURL = "mailto:" + this.emailContact + "?subject=Bug";
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    getURLForumReports() {
      const baseURL = this.URLForumReports;
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    getURLCompany() {
      const baseURL = this.URLCompany;
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    getURLForum() {
      const baseURL = this.URLForum;
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    getURLWebinarSubscription() {
      const baseURL = this.URLWebinarSubscription;
      return this.isCurrentUserGar ? URLGarSortieConfiance + baseURL : baseURL;
    },
    isProductionServer() {
      if (server != "production") return false;
      return true;
    },
    locale() {
      if (this.langsList.includes(this.$i18n.locale)) {
        return this.$i18n.locale;
      } else {
        return "en-US";
      }
    },
    country() {
      return this.locale.slice(-2).toLowerCase();
    },
    languageShortCode() {
      return this.locale.substring(0, 2).toLowerCase();
    },
    scholarSystem() {
      if (this.currentUser && this.currentUser.preferredScholarSystem) {
        console.log(
          "this.currentUser.preferredScholarSystem;",
          this.currentUser.preferredScholarSystem,
        );
        return this.currentUser.preferredScholarSystem;
      } else {
        var scholarSystemClosestToLocale = this.scholarSystemsList.find(
          (elt) => elt.codeLang == this.locale,
        );
        console.log(
          "scholarSystemClosestToLocale",
          scholarSystemClosestToLocale,
        );
        if (scholarSystemClosestToLocale) {
          return scholarSystemClosestToLocale.code;
        } else {
          return "US";
        }
      }
    },
    currentUser() {
      try {
        if (this.$store) {
          return this.$store.state.auth.user;
        }
      } catch (error) {
        console.log("error currentUser", error);
      }
    },
    currentUserFullName() {
      if (this.$store.state.auth.user) {
        let fullName = this.getFullName(
          this.$store.state.auth.user.firstName,
          this.$store.state.auth.user.lastName,
        );
        return fullName;
      } else {
        return "";
      }
    },

    currentUserRole() {
      let role = "";
      switch (true) {
        case this.checkPermission("menu_premium"):
          role = "Premium";
          break;
        case this.isCurrentUserFree:
          role = "Basic";
          break;
        case this.isCurrentUserInTeam:
          role = "Institutions";
          break;
        case this.isCurrentUserSuperAdmin:
          role = "SuperAdmin";
          break;
        case this.checkPermission("menu_admin"):
          role = "Admin";
          break;
      }
      if (this.isCurrentUserGar) {
        role += " GAR";
      } else if (this.isCurrentUserTabuleo) {
        role += " Tabuléo";
      }
      return role;
    },

    isCurrentUserAuthenticated() {
      if (this.$store.state.auth.user) {
        return true;
      } else {
        return false;
      }
    },

    /* Checking if the current user is a super admin. */
    isCurrentUserSuperAdmin() {
      if (this.currentUser && this.currentUser.role) {
        return this.currentUser.role == "ROLE_SUPERADMIN";
      }
      return false;
    },

    isCurrentUserAdmin() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_ADMIN" ||
          this.currentUser.role == "ROLE_SUPERADMIN"
        );
      }
      return false;
    },
    isCurrentUserPremiumOrMore() {
      console.log("isCurrentUserPremiumOrMore");
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_PREMIUM" ||
          this.isCurrentUserAdmin ||
          this.isCurrentUserInstitutionTeacher
        );
      }
      return false;
    },
    isCurrentUserFree() {
      if (this.currentUser && this.currentUser.role) {
        return this.currentUser.role == "ROLE_USER";
      }
      return false;
    },
    isCurrentUserTeamMember() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_TEAMMEMBER" ||
          this.currentUser.role == "ROLE_TEAMMEMBERGAR"
        );
      }
      return false;
    },
    isCurrentUserInTeam() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_TEAMMEMBER" ||
          this.currentUser.role == "ROLE_TEAMADMIN" ||
          this.currentUser.role == "ROLE_TEAMMANAGER" ||
          this.currentUser.role == "ROLE_TEAMADMINGAR" ||
          this.currentUser.role == "ROLE_TEAMMANAGERGAR" ||
          this.currentUser.role == "ROLE_TEAMMEMBERGAR"
        );
      }
      return false;
    },
    isCurrentUserTeamAdmin() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_TEAMADMIN" ||
          this.currentUser.role == "ROLE_TEAMADMINGAR"
        );
      }
      return false;
    },
    isCurrentUserTeamManager() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_TEAMMANAGER" ||
          this.currentUser.role == "ROLE_TEAMMANAGERGAR"
        );
      }
      return false;
    },

    // GAR Authentication et Institution

    isCurrentUserInstitution() {
      return this.isCurrentUserTabuleo || this.isCurrentUserGar;
    },

    isCurrentUserTabuleo() {
      if (this.currentUser && this.currentUser.role) {
        return (
          (this.isCurrentUserInstitutionTeacher ||
            this.currentUser.role == "ROLE_STUDENTGAR") &&
          this.currentUser.productId == 3
        );
      }
      return false;
    },

    isCurrentUserGar() {
      if (this.currentUser && this.currentUser.role) {
        return (
          (this.isCurrentUserGarTeacher ||
            this.currentUser.role == "ROLE_STUDENTGAR") &&
          (this.currentUser.productId == 1 || this.currentUser.productId == 2)
        );
      }
      return false;
    },

    isCurrentUserInstitutionTeacher() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_TEAMMANAGERGAR" ||
          this.currentUser.role == "ROLE_TEAMADMINGAR" ||
          this.currentUser.role == "ROLE_TEAMMEMBERGAR"
        );
      }
      return false;
    },

    isCurrentUserGarTeacher() {
      if (this.currentUser && this.currentUser.role) {
        return (
          (this.currentUser.role == "ROLE_TEAMMANAGERGAR" ||
            this.currentUser.role == "ROLE_TEAMADMINGAR" ||
            this.currentUser.role == "ROLE_TEAMMEMBERGAR") &&
          (this.currentUser.productId == 1 || this.currentUser.productId == 2)
        );
      }
      return false;
    },

    isCurrentUserStudent() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role == "ROLE_STUDENT" ||
          this.currentUser.role == "ROLE_STUDENTGAR"
        );
      }
      return false;
    },

    eledaVersion() {
      return packageInfo.version;
    },
    eledaVersionDate() {
      return packageInfo.date;
    },
  },
  mounted() {
    console.log("Mixin chargé");
  },

  methods: {
    // Gestionnaire d'erreur API unifié — à utiliser dans tous les .catch()
    // Ex : .catch(this.handleApiError) ou .catch(e => { this.isLoading = false; this.handleApiError(e); })
    handleApiError(error) {
      console.error(
        "[API error]",
        error?.config?.url ?? "",
        error?.message ?? error,
      );
      if (error?.response?.data) {
        this.showToast(
          {
            message: error.response.data.message,
            messageCode: error.response.data.messageCode,
          },
          "is-danger",
        );
      } else {
        // Erreur réseau (pas de réponse du serveur : timeout, CORS, offline…)
        this.showToast(
          "Une erreur s'est produite. Vérifiez votre connexion.",
          "is-danger",
        );
      }
    },

    getFullName(firstName, lastName) {
      if (firstName && lastName) {
        return firstName + "\u00A0" + lastName;
      } else if (firstName) {
        return firstName;
      } else if (lastName) {
        return lastName;
      } else {
        return "No name";
      }
    },

    // Single place to decide how a user's name is shown, so the GAR privacy
    // rule (surname only, gender-neutral "Ens." prefix, no first name) stays
    // consistent everywhere instead of being re-implemented per component.
    // `compact: true` additionally abbreviates the first name to its initial
    // for space-constrained spots (e.g. the header's nav bar label).
    getDisplayNameForUser(user, { compact = false } = {}) {
      if (!user) {
        return "";
      }
      // showFirstName === false: user opted out (or, for GAR institutional teacher
      // accounts, is forced by the backend) to not show their first name to others.
      if (user.showFirstName === false) {
        return "" + (user.lastName || "");
      }
      if (compact && user.firstName && user.lastName) {
        return user.firstName.charAt(0) + ". " + user.lastName;
      }
      return this.getFullName(user.firstName, user.lastName);
    },

    //those get method otherwise bug while rendering because props.row not yet loaded (BUG : props.row.user not defined)
    getUserIdFromProp(props) {
      if (props.row.user) {
        return props.row.user.id;
      } else return "";
    },

    getUsernameFromProp(props) {
      if (props.row.user) {
        return props.row.user.username.substring(0, 20);
      } else return "";
    },

    externalURL(url, garSortieConfianceURL) {
      var returnedUrl;
      if (this.isCurrentUserGar) {
        returnedUrl = garSortieConfianceURL + url;
      } else {
        returnedUrl = url;
      }
      console.log(
        "externalURL",
        this.eledaVersion,
        returnedUrl,
        garSortieConfianceURL,
      );
      return returnedUrl;
    },
    secondsToHms(seconds, useFullWords = false) {
      let hours = Math.floor(seconds / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      let remainingSeconds = seconds % 60;
      let durationString = "";

      if (hours > 0) {
        if (useFullWords) {
          durationString +=
            hours === 1
              ? this.$t("SequenceStats.HOUR")
              : `${hours} ` + this.$t("SequenceStats.HOURS");
        } else {
          durationString += `${hours} ` + this.$t("SequenceStats.HOUR_SHORT");
        }
        if (minutes > 0 || remainingSeconds > 0) {
          durationString += ", ";
        }
      }
      if (minutes > 0) {
        if (useFullWords) {
          durationString +=
            minutes === 1
              ? this.$t("SequenceStats.MINUTE")
              : `${minutes} ` + this.$t("SequenceStats.MINUTES");
        } else {
          durationString +=
            `${minutes} ` + this.$t("SequenceStats.MINUTE_SHORT");
        }
        if (remainingSeconds > 0) {
          durationString += ", ";
        }
      }
      if (remainingSeconds > 0) {
        if (useFullWords) {
          durationString +=
            remainingSeconds === 1
              ? this.$t("SequenceStats.SECOND")
              : `${remainingSeconds} ` + this.$t("SequenceStats.SECONDS");
        } else {
          durationString +=
            `${remainingSeconds} ` + this.$t("SequenceStats.SECOND_SHORT");
        }
      }

      return durationString;
    },

    /**
     * Go to #top after clicking. Triggered after click on pagination
     * @param {Integer} page
     */
    scrollToTop() {
      //Put in a setTimeOut 0ms to apply after the component parent "refresh"
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 0);
    },

    getVersionLabelFromVersionNumber(versionNumber, versions) {
      if (Array.isArray(versions) && versions.length > 0) {
        if (versionNumber == -1) {
          return this.$t("Use.VERSION_RANDOM");
        } else {
          return versions.find((version) => version.number == versionNumber)
            ?.label;
        }
      } else {
        return null;
      }
    },

    getDefaultVersion(versions) {
      if (Array.isArray(versions) && versions.length > 0) {
        let defaultVersion = versions.find((version) => version.number == -1);
        return versions.find(
          (version) =>
            version.number != -1 && version.label == defaultVersion.label,
        );
      } else {
        return null;
      }
    },

    getActivityTitle(activity) {
      let lang = activity.langs.find((lang) => lang.code == this.locale);
      if (lang) {
        return lang.title;
      } else if (activity.langs.find((lang) => lang.default)) {
        return activity.langs.find((lang) => lang.default).title;
      } else {
        //retrocompatibility //display namefile if defaultTitle is absent
        return activity.name;
      }
    },
    getActivityDescription(activity) {
      let lang = activity.langs.find((lang) => lang.code == this.locale);
      if (lang) {
        return lang.description;
      } else if (activity.langs.find((lang) => lang.default)) {
        return activity.langs.find((lang) => lang.default).description;
      } else {
        //display if description absent
        return "not defined";
      }
    },
    getTagLocale(tag) {
      if (typeof tag === "string") {
        return tag;
      }
      switch (true) {
        case tag.template === null:
          // case of new tag from activityEdit (just text not created in database)
          return tag;
        case tag.template == 1:
          var str = this.scholarSystemsList.find(
            (elt) => elt.code == this.scholarSystem,
          ).levels[tag.name];
          if (str) return str;
          else {
            return "Tag error";
          }
        case tag.template == 5:
          var str = this.scholarSystemsList.find(
            (elt) => elt.code == this.scholarSystem,
          ).levels[tag.name];
          if (str) return str;
          else {
            return tag.name;
          }
        case tag.template == 3 || tag.template == 4 || tag.template == 10:
          return tag.name; //case of lang or custom tag type
        default:
          return this.$t("Tags." + tag.name); //other tags standards (level, grade) which are translated
      }
    },

    getTagType(tag, isLight = false, isActive = false) {
      let type = "";
      let contrast = "";
      if (isLight) {
        contrast = " is-light";
      }
      switch (tag.template) {
        case 1:
          type = "is-primary";
          break; //level (Primary...)
        case 2:
          type = "is-success";
          break; //field (Math...)
        case 3:
          type = "is-warning";
          break; // lang //lang is sometimes converted into tag when tags are selectable in UI with a template=3 otherwise getLangType should be called
        case 4:
          type = "is-info";
          break; //certification / stamp
        case 5:
          type = "is-orange";
          break; //top
        case 10:
          type = "is-orange";
          break; //custom tag
        default:
          type = "is-danger"; // means that tag has not template : it's a new one create in ActivityEdit
      }

      if (isActive) {
        contrast = "";
      }

      return type + contrast;
    },
    /**
     * Return the default type of a Lang "Tag". Use when the lang is only displayed, otherwise (if tag is selectable use Lang is converted into Tag).
     * @param {*} isLight
     * @returns
     */
    getLangType(isLight = false) {
      let contrast = "";
      if (isLight) {
        contrast = " is-light";
      }
      return "is-warning" + contrast;
    },

    getColorNumberOfBlocks(nbBlocks) {
      switch (true) {
        case nbBlocks < 80:
          return {
            class: "has-text-success",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP.SUPEREASY")[0],
          };
        case nbBlocks < 150:
          return {
            class: "has-text-success-dark",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP")[1],
          };
        case nbBlocks < 250:
          return {
            class: "has-text-warning",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP")[2],
          };
        case nbBlocks < 400:
          return {
            class: "has-text-warning",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP")[2],
          };
        case nbBlocks < 600:
          return {
            class: "has-text-orange",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP")[3],
          };
        case nbBlocks < 900:
          return {
            class: "has-text-orange",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP")[3],
          };
        case nbBlocks < 1500:
          return {
            class: "has-text-danger",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP")[4],
          };
        default:
          return {
            class: "has-text-danger-dark",
            tooltip: this.$t("Use.NB_BLOCKS_TOOLTIP")[5],
          };
      }
    },

    // Dans votre mixin
    checkTokenValidity() {
      if (this.isCurrentUserAuthenticated) {
        return isTokenValid();
      }
      return true; // Si l'utilisateur n'est pas authentifié, on considère le token comme valide
    },

    logOut() {
      console.log("logOut", this.user);
      clearAutoLogout(); // annule le timer auto-logout (déconnexion volontaire)
      this.$store.dispatch("auth/logout", this.user).then(
        (response) => {
          this.$store.state.auth.user = null;
          this.$store.commit("setAuthUser", null);
          localStorage.removeItem("user");
        },
        (error) => {
          this.$store.state.auth.user = null;
          this.$store.commit("setAuthUser", null);
          localStorage.removeItem("user");
        },
      );
    },

    async updateClipboard(text, i18nRef = "ShareModal.LINKCOPY") {
      try {
        await navigator.clipboard.writeText(text);
        this.showToast(this.$t(i18nRef), "is-success");
      } catch (error) {
        this.showToast(this.$t("errors.MESSAGE.400"));
      }
    },

    setCookie(cname, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = cname + "=" + (value || "") + expires + "; path=/";
    },

    deleteCookie(cname) {
      document.cookie =
        cname +
        "=anonymous" +
        "; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    },
    downloadFileFromData(data, mime, label) {
      const blob = new Blob([data], { type: mime });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    },

    updateUserRole(userId, newRole) {
      UserDataService.updateUserRole(userId, newRole)
        .then(() => {
          this.$buefy.snackbar.open({
            message: "User role updated",
            type: "is-success",
            position: "is-top",
            actionText: null,
          });
        })
        .catch(this.handleApiError);
    },

    // méthodes pour vérifier les permissions d'un utilisateur

    checkPermission(permission) {
      if (this.currentUser) {
        if (
          !Object.prototype.hasOwnProperty.call(this.currentUser, "permissions")
        ) {
          localStorage.removeItem("user");
          this.logOut();
          return false;
        } else {
          for (let i = 0; i < this.currentUser.permissions.length; i++) {
            if (this.currentUser.permissions[i].name == permission) {
              return true;
            }
          }
        }
      }
      return false;
    },

    showToast(object, type, iconUrl = null) {
      if (object.messageCode || object.message) {
        let messageHTML = "";

        if (object.messageCode) {
          messageHTML = this.$i18n.t("errors.MESSAGE." + object.messageCode);
        }
        if (object.message) {
          messageHTML += messageHTML
            ? "<br/>" + object.message
            : object.message;
        }

        let iconHTML = iconUrl
          ? `<img src="${iconUrl}" alt="icon" style="width: 24px; height: 24px; margin-right: 10px;">`
          : "";

        this.$buefy.toast.open({
          message: `<div style="display: flex; align-items: center;">
                  ${iconHTML}
                  <span>${messageHTML}</span>
                </div>`,
          duration: 5000,
          type: type ? type : "is-danger",
          dangerouslySetInnerHTML: true,
        });
      } else {
        let iconHTML = iconUrl
          ? `<img src="${iconUrl}" alt="icon" style="width: 24px; height: 24px; margin-right: 10px;">`
          : "";

        this.$buefy.toast.open({
          message: `<div style="display: flex; align-items: center;">
                  ${iconHTML}
                  <span>${object}</span>
                </div>`,
          duration: 5000,
          type: type ? type : "is-danger",
          dangerouslySetInnerHTML: true,
        });
      }
    },
  },
};
